import styled from 'styled-components';

import {Skeleton} from '~/shared/components/Loaders';
import {Row, TableMobileWrapper} from '~/shared/components/UserTransactions/components/styled';

const PaymentMethodWrapper = styled.div`
  width: 120px;
`;

const CardSuffixWrapper = styled.div`
  flex: 1;
`;

// TODO: Skeleton, styled - needs to be rewritten as ts

const MobileLoaderComponent = () => (
  <TableMobileWrapper>
    <Row spaceBetween>
      <PaymentMethodWrapper>
        <Skeleton width={65} height={16} />
      </PaymentMethodWrapper>
      <CardSuffixWrapper>
        <Skeleton width={65} height={16} />
      </CardSuffixWrapper>
      <Skeleton width={65} height={16} />
    </Row>
    <Row spaceBetween>
      <PaymentMethodWrapper>
        <Skeleton width={65} height={16} />
      </PaymentMethodWrapper>
      <CardSuffixWrapper>
        <Skeleton width={65} height={16} />
      </CardSuffixWrapper>
      <Skeleton width={65} height={16} />
    </Row>
    <Row spaceBetween>
      <PaymentMethodWrapper>
        <Skeleton width={65} height={16} />
      </PaymentMethodWrapper>
      <CardSuffixWrapper>
        <Skeleton width={65} height={16} />
      </CardSuffixWrapper>
      <Skeleton width={65} height={16} />
    </Row>
  </TableMobileWrapper>
);

export default MobileLoaderComponent;
